// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../themes/Colors.css'","lines":"#e5e5e5","cont":"Input_cont__YunuS","error":"Input_error__DLVgR","label":"Input_label__3BesJ"};